import React, { useState, useEffect } from "react";
import {
    Space,
    Row,
    Col,
    Switch,
    Form,
    Input,
    Button,
    message,
    InputNumber,
    Select,
    Skeleton,
    Alert
} from "antd";
import { gql, useMutation, useLazyQuery } from "@apollo/client";
import DeleteDiscount from "@general/deleteDiscount";
import DatePicker from "@general/datePicker";
import moment from "moment-jalaali";
import DeleteMessage from "@general/deleteMessage";
import DeactivateMessage from "@general/deacticateMessage";
import ActivateMessage from "@general/activateMessage";

function MessageForm({ formData, onDoUpdateData, onDoCloseDrawer, id }) {
    const [form] = Form.useForm();
    const [error, setError] = useState(null);
    const [editable, setEditable] = useState(false);
    const { TextArea } = Input;
    const [selectableUsers, setSelectableUsers] = useState([]);

    const UPDATEMESSAGE = gql`
        mutation updateMessage($id: ID!, $updateInput: UpdateMessageInput!){
            updateMessage(id: $id, updateInput: $updateInput)
        }
  `
    const GETMESSAGE = gql`
    query {
        getBirthdayMessage{
            id
            createdAt
            title
            body
        }
    }
  `;

    const GETUSERS = gql`
      query ($paginateInput: PaginateInput!, $searchInput: UserSearchInput!) {
        getUsers(paginateInput: $paginateInput, searchInput: $searchInput) {
          id
          name
          mobile
        }
      }
    `;


    const [getUsers, users] = useLazyQuery(
        GETUSERS,
        {
            onCompleted({ getUsers }) {
                const arrangedUsers = [{ value: "all", label: "همه کاربران" }];
                getUsers.map((user) => {
                    arrangedUsers.push({
                        value: user.id,
                        label: user.name ? user.name : user.mobile,
                    });
                });
                setSelectableUsers(arrangedUsers);
            },

        }
    );
    useEffect(() => {
        form.setFieldsValue(formData);
        getUsers({
            variables: {
                paginateInput: {
                    page: 1,
                    perPage: 500,
                },
                searchInput: {
                    userRole: 'USER'
                }
            },
        });
    }, []);

    const [runUpdateMessage, updateMessage] = useMutation(UPDATEMESSAGE, {
        onCompleted() {
            message.success("اطلاعات پیام بروزرسانی شد.");
            onDoUpdateData();
        },
        onError(err) {
            console.log("خطا: " + err.message);
            message.error("مشکلی پیش آمده! پیام بروزرسانی نشد.");
        },
    });


    const onDoUpdateMessage = (updateMessageInput) => {
        if (updateMessageInput.userIds[0] === "all" || updateMessageInput.userIds === "all") updateMessageInput.userIds = [];

        runUpdateMessage({
            variables: {
                id,
                updateInput: {
                    ...updateMessageInput,
                    expiresAt: updateMessageInput.expiresAt ?? null,
                    type: 'BROADCAST'
                },
            },
        });
    };

    if (!formData || users.loading)
        return (
            <>
                <Skeleton active round />
                <br />
                <Skeleton active round />
            </>
        );
    if (users.error) {
        console.log(users.error)
        return <p>در فراخوانی کاربرها خطایی رخ داده است.</p>
    }
    else
        return (
            <>
                <Row>
                    <Space align>
                        <p>ویرایش: </p>
                        <Switch onChange={() => setEditable(!editable)} />
                    </Space>
                </Row>
                <Form
                    layout="vertical"
                    onFinish={onDoUpdateMessage}
                    form={form}
                    disabled={!editable}
                >
                    <Row>
                        <Col xs={24}>

                            <Row>
                                <Form.Item
                                    name="title"
                                    id="title"
                                    style={{ width: "50%" }}
                                    label="عنوان"
                                    rules={[
                                        {
                                            required: true,
                                            message: "لطفا عنوان را وارد کنید!",
                                        },
                                    ]}
                                    validateStatus={error && "error"}
                                >
                                    <Input className="form-input" placeholder={"عنوان"} />
                                </Form.Item>
                            </Row>

                            <Row>
                                <Form.Item
                                    name="body"
                                    id="body"
                                    style={{ width: "100%" }}
                                    label="پیام"
                                    rules={[
                                        {
                                            required: true,
                                            message: "لطفا پیام را وارد کنید!",
                                        },
                                    ]}
                                    validateStatus={error && "error"}
                                >
                                    <TextArea placeholder="پیام" rows={6} />

                                </Form.Item>
                            </Row>


                            <Row> <Col xs={12} md={12}>
                                <Form.Item
                                    name="userIds"
                                    id="userIds"
                                    label="کاربران مشمول"
                                    rules={[
                                        {
                                            required: true,
                                            message: "لطفا نام کاربران مشمول تخفیف را انتخاب کنید!",
                                        },
                                    ]}
                                    validateStatus={error && "error"}
                                >
                                    <Select
                                        showSearch
                                        mode="multiple"
                                        allowClear
                                        loading={users.loading}
                                        listHeight={200}
                                        style={{
                                            width: 280,
                                        }}
                                        placeholder={"کاربران"}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").includes(input)
                                        }
                                        filterSort={(optionB, optionA) =>
                                            (optionA?.label ?? "")
                                                .toLowerCase()
                                                .localeCompare((optionB?.label ?? "").toLowerCase())
                                        }
                                        options={selectableUsers}
                                    />
                                </Form.Item>
                            </Col>
                                <Col xs={12} md={12}>
                                    <Form.Item
                                        label="تاریخ انقضا"
                                        name="expiresAt"
                                    >
                                        <DatePicker
                                            showToday={false}
                                            format="YYYY/MM/DD"
                                            style={{ width: "100%" }}
                                            className="rtl"
                                            placeholder="تاریخ انقضا"
                                            disabledDate={(current) => current < moment().endOf("day")}
                                        />
                                    </Form.Item></Col>
                            </Row>



                        </Col>

                    </Row>
                    <Row>
                        <Col xs={12} md={12}>
                            <Alert
                                description="USER_NAME = نام و نام خانوادگی"
                                type="info"
                                banner
                                style={{ width: "100%", marginBottom: "30px" }}
                            /></Col>
                    </Row>


                    <Space style={{ marginTop: "20px" }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={updateMessage.loading && true}
                        >
                            به روزرسانی
                        </Button>
                        <DeleteMessage
                            id={id}
                            onDeleteMessage={onDoUpdateData}
                            closeDrawer={onDoCloseDrawer}
                        >
                            <Button danger type="text">
                                حذف پیام
                            </Button>

                        </DeleteMessage>
                        {formData?.isActive ? (
                            <DeactivateMessage
                                id={formData?.id}
                                title={formData?.title}
                                onDeactivateMessage={() => {
                                    onDoUpdateData();
                                    onDoCloseDrawer();

                                }}
                            >
                                <Button danger>غیرفعال کردن</Button>
                            </DeactivateMessage>
                        ) : (
                            <ActivateMessage
                                id={formData?.id}
                                title={formData?.title}
                                onActivateMessage={() => {
                                    onDoUpdateData();
                                    onDoCloseDrawer();
                                }}
                            >
                                <Button success>فعال کردن</Button>
                            </ActivateMessage>
                        )}
                    </Space>
                </Form>
            </>
        );
}

export default MessageForm;
